import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { isIOS, isSafari } from 'react-device-detect';
import { useState } from 'react';

const MOBILE_DEEPLINK: string = 'portal1.notecast.app';
const APP_STORE_URL: string =
  'https://apps.apple.com/us/app/inflo/id1439173564';

const AppstoreBannerWrapper = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 14px;
  height: 10%;
  color: white;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(40px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  z-index: 999;
  white-space: 'nowrap';
  padding-left: 8px;
`;

const CloseBannerButtonDiv = styled.div`
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  border: '1px solid red';

  &:hover {
    background-color: var(--color-medium-pink);
    transition: ease-in 100ms;
  }
`;

const InfloTextDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding-left: 4px;
  padding-right: 4px;
`;

const InfloAppButtonDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 24px;
  padding-right: 10px;

  @media (orientation: landscape) {
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 24px;
    padding-right: 10px;
  }
`;

const InfloAppButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-royal-purple);
  border-radius: 12px;
  cursor: pointer;
  white-space: nowrap;
  height: 90%;
  border: none;
  outline: none;
  padding-left: 20px;
  padding-right: 20px;

  &:hover {
    background-color: var(--color-medium-pink);
    transition: ease-in 100ms;
  }
`;

function AppstoreBanner() {
  const [isAppstoreBannerOpen, setIsAppstoreBannerOpen] = useState<boolean>(
    true
  );

  const isPdfViewerPage = window.location.pathname.includes('/pdf-viewer');

  // Handle App redirection
  function handleAppButtonClick() {
    window.location.href = `${MOBILE_DEEPLINK}://`;
    setTimeout(() => {
      window.location.href = APP_STORE_URL;
    }, 2000);
  }

  if (!isIOS || !isAppstoreBannerOpen) {
    return null;
  }

  return (
    <>
      {isSafari && !isPdfViewerPage && (
        <Helmet>
          <meta
            name="apple-itunes-app"
            content="app-id=1439173564, app-argument=https://apps.apple.com/us/app/inflo/id1439173564"
          />
        </Helmet>
      )}

      {!isSafari && (
        <AppstoreBannerWrapper>
          <CloseBannerButtonDiv onClick={() => setIsAppstoreBannerOpen(false)}>
            x
          </CloseBannerButtonDiv>
          <InfloTextDiv>
            <img
              src="/favicon-inflo24-32x32.png"
              alt="INFLO Logo"
              width="40px"
              height="40px"
              style={{ marginRight: '8px' }}
            />
            Download the INFLO App from the App Store!
          </InfloTextDiv>
          <InfloAppButtonDiv>
            <InfloAppButton onClick={handleAppButtonClick}>
              INFLO App
            </InfloAppButton>
          </InfloAppButtonDiv>
        </AppstoreBannerWrapper>
      )}
    </>
  );
}

export default AppstoreBanner;
